import React, { FC } from 'react'
import SectionTitle from 'src/components/typography/SectionTitle'
import {
  IInternationalCompetition,
} from 'src/components/laws/ParticipatingCompetitions'

interface IInternationalCompetitionsProps {
  label: string
  competitions: Array<IInternationalCompetition>
}

const Competition = ({ logoUrl, name }: IInternationalCompetition) => (
  <li
    key={name}
    className="flex flex-wrap justifyitems-center justify-center mb-6"
  >
    <img src={logoUrl} alt={name} className="w-12 h-12" />
    <p className="whitespace-pre text-center w-full mt-1">{name}</p>
  </li>
)

const InternationalCompetitions: FC<IInternationalCompetitionsProps> = ({
  label,
  competitions,
}) => {
  if (competitions?.length === 0) {
    return <></>
  }

  const mappedCompetitionsToComponents = competitions.map((competition) =>
    Competition(competition)
  )

  return (
    <>
      <SectionTitle>
        {label}
      </SectionTitle>
      <ul className="grid grid-rows-12 grid-cols-3 lg:grid-cols-5">
        {mappedCompetitionsToComponents}
      </ul>
    </>
  )
}

export default InternationalCompetitions
